import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useLocale } from "../stores/locale";
import { Button } from "./button";
export function BackLink() {
  const { locale: t } = useLocale();
  return (
    <Button className=" w-fit" href="/" type="route">
      <FontAwesomeIcon icon={faArrowLeft} />
      {t.back}
    </Button>
  );
}
